import { action, makeAutoObservable, flow } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'
import memberStore from './memberStore'

class CreditStore {
    chain = undefined
    memberCreditRecords = []
    memberCreditRecordCount = 0
    creditRecords = []
    creditRecordCount = 0

    constructor() {
        makeAutoObservable(this)
    }

    getChain = flow(function* () {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.getChain(token)
            this.chain = response.data
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    createCredit = flow(function* (userId, billPrice, remark) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.createCredit(token, userId, billPrice, remark)
            memberStore.updateMember(userId, response.data)
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listUserCredit = flow(function* (userId, skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listUserCredit(token, userId, 5, skip)
            const { records, count } = response.data
            this.memberCreditRecords = records
            this.memberCreditRecordCount = count
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreUserCredit = flow(function* (userId, skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listUserCredit(token, userId, 5, skip)
            const { records, count } = response.data
            this.memberCreditRecords = _.union(this.memberCreditRecords, records)
            this.memberCreditRecordCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listCredit = flow(function* (skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listCredit(token, 20, skip)
            const { records, count } = response.data
            this.creditRecords = records
            this.creditRecordCount = count
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreUserCredit = flow(function* (skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listCredit(token, 20, skip)
            const { records, count } = response.data
            this.creditRecords = _.union(this.creditRecords, records)
            this.creditRecordCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

}

export default new CreditStore()